var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServicePageLayout',{attrs:{"title":"Users","subtitle":"บริหารจัดการผู้ใช้งาน","icon":"mdi-account-multiple-check-outline","breadcrumb":"System"}},[_c('v-card',{staticClass:"service-content-panel",attrs:{"flat":""}},[_c('v-card-text',[_c('USERS_DATATABLE')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }